var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplied = function SvgReplied(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.0497 3.32227V6.07227C12.4249 6.07227 15.1608 8.80821 15.1608 12.1834C15.1608 12.3502 15.1547 12.5152 15.1413 12.6784C14.2472 10.9832 12.4951 9.81165 10.4632 9.74199L10.2719 9.73893H9.0497V12.4889L4.16081 7.9056L9.0497 3.32227ZM5.38303 3.32227V4.99488L2.27859 7.9056L5.38242 10.8151L5.38303 12.4889L0.494141 7.9056L5.38303 3.32227ZM7.82747 6.14315L5.9477 7.9056L7.82747 9.66743V8.51671H10.2927L10.5048 8.52099C11.29 8.54727 12.0472 8.71043 12.7512 8.9891C11.8547 7.95143 10.5286 7.29449 9.0497 7.29449H7.82747V6.14315Z"
  })));
};
export default SvgReplied;